import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification, NotificationType } from '../../../core/interfaces/notifications-interface';
import { TranslocoPipe } from '@jsverse/transloco';
import { IsoToFormattedDatePipe } from "../../../core/pipes/iso-to-formatted-date.pipe";


@Component({
  selector: 'app-notifications-popup',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, IsoToFormattedDatePipe],
  templateUrl: './notifications-popup.component.html',
  styleUrl: './notifications-popup.component.css'
})
export class NotificationsPopupComponent {
  alertType = NotificationType.ALERT;

  @Input() notifications: Notification[] = [];
  @Output() markAsRead = new EventEmitter<string>();

  @Input() loadMore!: () => void;
  loading = false;

  @Input() waitingForNextPageResponse: boolean = false;


  expanded: { [id: string]: boolean } = {};

  toggleExpand(id: string) {
    this.expanded[id] = !this.expanded[id];
  }

  isExpanded(id: string): boolean {
    return this.expanded[id];
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;

    const atBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 10;

    if (atBottom && !this.loading) {
      this.loading = true;

      this.loadMore?.();
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
}
